export const wrapStorage = (prefix, storage) => {
  const patch = (k) => prefix + "$$" + k;

  return {
    setItem: (name, value) => storage.setItem(patch(name), value),
    getItem: (name) => storage.getItem(patch(name)),
    removeItem: (name) => storage.removeItem(patch(name)),
  };
};
